import { useEffect, useState } from 'react';
import axios from 'axios';

const useCountryDetector = () => {
    const [isRestricted, setIsRestricted] = useState(false);
    const [userCountry, setUserCountry] = useState(null);
    const [detectionComplete, setDetectionComplete] = useState(false);

    useEffect(() => {
        const detectCountry = async () => {
            try {
                
                const ipResponse = await axios.get('https://api.ipify.org?format=json');
                const ip = ipResponse.data.ip;

                let country = null;

                try {
                    const res = await axios.get(`https://ipapi.co/${ip}/json/`);
                    country = res.data.country_name;
                } catch (ipapiErr) {
                    console.warn('ipapi.co failed, trying ip-api.com...', ipapiErr);

                    
                    try {
                        const res = await axios.get(`http://ip-api.com/json/${ip}`);
                        country = res.data.country;
                    } catch (fallbackErr) {
                        console.warn('ip-api fallback failed.', fallbackErr);
                    }
                }

                if (!country) {
                    setIsRestricted(true);
                } else {
                    setUserCountry(country);
                    setIsRestricted(country !== 'India');
                }
            } catch (error) {
                console.error("Country detection failed:", error);
                setIsRestricted(true);
            } finally {
                setDetectionComplete(true);
            }
        };

        detectCountry();
    }, []);

    return { isRestricted, userCountry, detectionComplete };
};

export default useCountryDetector;
